import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "./components/Header";
import Ad from "./components/pages/Ad";
import Campaign from "./components/pages/Campaign";
import Home from "./components/pages/Home";
import Hype from "./components/pages/Hype";

const App = () => {
  return (
    <>
      <Router>
        <Header />
        <Switch>
          <Route path="/ad">
            <Ad />
          </Route>
          <Route path="/campaign">
            <Campaign />
          </Route>
          <Route path="/hype">
            <Hype />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  );
};

export default App;
